import { Usuario } from './usuario';
import { UnidadAdministrativa } from './unidad-administrativa';

export class UsuarioXRolXUnidad {

    idUsuarioXRolXUnidad: number;
   
    idAplicativo: string;

    idRol: string;
   

    estaActivo: boolean;

    /**
     * si administraa el aplicativo, debe necesiar unidad
     */
    administraAplicativo: boolean;

    usuarioCreacion: string;

    fechaCreacion: Date;

    usuarioAcualizacion: string;

    fechaActualizacion: Date;

    unidadAdministrativa: UnidadAdministrativa;

    usuario: Usuario;

    

}
